
import { Component, Vue } from 'vue-property-decorator'
import { State, Action, Mutation } from 'vuex-class'
import Price from '@/components/price/index.vue'
import Header from '@/common/header.vue'
import Footer from '@/common/footer.vue'
import {
  createOrder,
  createOrderBuy,
  // getDefaultAddress,
  getFreight,
  addressList,
  saveAddress,
  invoiceList,
  saveInvoice,
  searchInvoiceName,
  searchInvoiceNo,
  getIntegralDeduction,
  pageVisit,
  getDataCard,
  getDataBanner,
  getDataReCommend,
  getDataProType,
  integralExchangeOrder,
  createBargainOrder,
  getUseCoupon,
  updateBuyNum,
  exchangeProductInfo,
} from '@/services/http'
import { readCookie, dateTimeFormatter, readStorage } from '@/tools/tools'
import { validateTelPhone, validateTaxNumber, validateEmail } from '@/tools/regexp'
import * as _ from 'lodash'
import addData from '../../assets/json/address.json'

@Component({
  name: 'OrderConfirm',
  components: {
    Header,
    Price,
    Footer,
  },
})
export default class extends Vue {
  deductionList: any = {}

  isDeduction: boolean = false

  // 是否有可用积分
  isDeficiency: boolean = false

  isIntegral: boolean = false

  useIntegral: number = 0

  constTotal: number = 0

  shoppingList: any[] = []

  // 选择收货地址
  addressList: any[] = []

  // 全部地址列表信息
  addLists: any[] = []

  currentIndex: number = 0

  options: any[] = []

  cityOptions: any[] = []

  areaOptions: any[] = []

  invoiceVisible: boolean = false

  isInvoice: boolean = false

  isSelectInvoice: boolean = false

  isInvoiceDisabled: boolean = false

  // 留言
  remark: string = ''

  invoiceList: any[] = []

  // 是否是通过列表编辑地址
  isModifyAddress: boolean = false

  selectInvoiceList: any[] = []

  // 商品列表id
  cartIds: string = ''

  // 地址id
  addressId: string = ''

  addIndex: number = -1

  // 是否编辑发票
  isEditInvoice: boolean = false

  invoiceIndex: number = -1

  // 单笔订单金额上限为100,000 元
  isdisabled: boolean = false

  showDialogBack: boolean = false

  // 运费总价格
  freightprice: number = 0

  // 合计（商品总价格+运费总价格:大于10万不让提交订单）
  total: number = 0

  minInvoice: number = 0

  // 发票id
  invoiceId: string = ''

  addressVisible: boolean = false

  value: any[] = []

  addRuleForm: any = {
    id: '',
    realName: '',
    telephone: '',
    address: '',
    detailAddress: '',
    defaultAddress: 0,
    provinceId: '',
    cityId: '',
    areaId: '',
    provinceName: '',
    cityName: '',
    areaName: '',
  }

  addrules: object = {
    realName: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
    telephone: [{ required: true, validator: validateTelPhone, trigger: 'blur' }],
    areaId: [
      {
        required: true,
        message: '请选择地址',
      },
    ],
    addressTemp: [{ required: true, message: '请输入详细地址', trigger: 'blur' }],
  }

  loading: boolean = false

  // 是否是新增新地址
  isAddNewAddress: boolean = false

  form: any = {
    id: '',
    // 所选发票类型(1、个人发票2、公司增值税电子普票3、增值税电子专票)
    invoiceType: 1,
    invoiceName: '',
    invoiceNo: '',
    companyAddress: '',
    bankNo: '',
    telephone: '',
    bank: '',
    equip: '',
    version: '',
    companyId: 1,
    email: '', // 接受邮箱
  }

  companyList: [] = []

  rules: object = {
    invoiceName: [{ required: true, message: '请填写名称', trigger: 'blur' }],
    companyAddress: [{ required: true, message: '请填写注册地址', trigger: 'blur' }],
    telephone: [{ required: true, message: '请填写电话号码', trigger: 'blur' }],
    invoiceNo: [{ required: true, validator: validateTaxNumber, trigger: 'blur' }],
    bankNo: [{ required: true, message: '请填写银行账号', trigger: 'blur' }],
    bank: [{ required: true, message: '请填写银行账号', trigger: 'blur' }],
    email: [{ required: true, validator: validateEmail, trigger: 'blur' }],
  }

  integralInfo: any = readStorage('integralInfo')

  couponLoading: boolean = false

  couponDialog: boolean = false

  couponIndex: any = ''

  couponPrice: any = 0

  isCoupon: boolean = false

  couponList: any[] = []

  isLoading: boolean = false

  // 限时抢购可抢最大上限
  limitNum: number = 1

  // 是否从限时抢购进入
  isFromFlash: boolean = false

  //赠品信息
  giftMap: any = {} 

  @State('order') orderdata: any

  @State('address') addressdata: any

  @Action('card/setCardNum') setCardNum!: Function

  @Mutation('order/CONFIRMORDER') CONFIRMORDER!: Function

  get maxVal(): number {
    // 积分deductIntegral、金额deductAmount、最多可使用多少积分deductMax
    const { deductIntegral, deductAmount, deductMax, deductMin } = (this as any).deductionList
      .mallIntegralUseRule

    // 每积分抵现多少元
    const price = deductAmount / deductIntegral

    // 最多可抵扣多少元mostPrice、当前用户积分integral
    const { mostPrice, integral } = (this as any).deductionList

    if (mostPrice > 0) {
      if (integral < deductIntegral) {
        return this.useIntegral
      }

      if (this.total < price * deductIntegral) {
        return this.useIntegral
      }

      if (deductMax) {
        if (Math.floor(mostPrice / price) < deductIntegral) {
          return 0
        }
      }
      if (deductMin) {
        if (deductMin > integral) {
          return 0
        }
      }
      return Math.floor(mostPrice / price)
    }
    return 0
  }

  async created() {
    await this.setConfirmData()
    await this.addressLists()
    await this.getAddress()
    await this.setData()
    await this.pageVisit()
    this.getUseCoupon()
    this.getDeficiency()
  }

  //  判断是否有可用积分
  getDeficiency() {
    if (this.$route.query.bargain) {
      this.deductionList.discountAmount = 0
    }
    this.isDeficiency =
      (this.integralInfo &&
        this.integralInfo.ruleType === 1 &&
        this.deductionList.integral < this.integralInfo.integral) ||
      (this.integralInfo &&
        this.integralInfo.ruleType === 2 &&
        this.deductionList.integral < this.integralInfo.maxIntegral)
  }

  useCoupont(item: any) {
    // if (this.couponIndex === item.id) {
    //   this.couponIndex = '';
    //   this.couponPrice = 0;
    //   return;
    // }
    this.couponPrice = item.reduceMoney
    this.couponIndex = item.id
    this.changeUseInteral()
    if (this.total < 0) {
      this.needDeduction()
    }
  }

  // 获取可使用优惠券列表
  async getUseCoupon() {
    const { type } = this.$route.query
    const productIdPrice: any = this.shoppingList.map((item: any) => ({
      productId: item.productId,
      price: type === '1' ? _.round(_.multiply(item.price, item.num), 2) : this.totalPrice,
    }))
    const res: any = await getUseCoupon({
      productIdPrice: JSON.stringify(productIdPrice),
      companyId: 1,
    })
    if (res.data.code === 100) {
      this.couponList = res.data.data.map((item: any) => {
        const data: any = item
        data.useEndDate = dateTimeFormatter(item.useEndDate)
        return data
      })
      this.couponLoading = false
    }
  }

  needCoupon() {
    this.isCoupon = !this.isCoupon
    if (!this.isCoupon) {
      this.couponIndex = ''
      this.couponPrice = 0
      this.changeUseInteral()
      // const deductPrice = _.round(
      //   _.divide(
      //     _.divide(
      //       this.useIntegral,
      //       (this as any).deductionList.mallIntegralUseRule.deductIntegral
      //     ),
      //     (this as any).deductionList.mallIntegralUseRule.deductAmount
      //   ),
      //   2
      // );
      // const objects = [
      //   { n: this.constTotal },
      //   { n: -deductPrice },
      //   { n: -this.couponPrice }
      // ];
      // this.total = _.round(_.sumBy(objects, 'n'), 2) < 0
      //   ? 0
      //   : _.round(_.sumBy(objects, 'n'), 2);
      // this.isInvoiceDisabled = _.subtract(this.total, this.minInvoice) < 0;
      // this.isdisabled = this.total > 100000;
    }
  }

  // 设置初始联动数据
  setData() {
    this.options = addData.data
  }

  needInvoice() {
    this.isInvoice = !this.isInvoice
    if (!this.isInvoice) {
      this.invoiceId = ''
    }
  }

  needDeduction() {
    this.isIntegral = false
    this.isDeduction = !this.isDeduction
    if (!this.isDeduction) {
      this.invoiceId = ''
      this.useIntegral = 0
    } else {
      this.$nextTick(() => {
        const ipt: any = (this.$refs.inputNumber as any)?.$el?.querySelector('input')
        if (ipt) ipt.setAttribute('readonly', true)
      })
    }
    this.changeUseInteral()
  }

  async needIntegral() {
    if (this.isDeficiency) return
    if (this.isDeficiency && this.total - this.integralInfo.discountAmount < 0) {
      this.$message.error('实付金额不能小于0')
      this.isIntegral = false
      return
    }
    this.isDeduction = false
    this.isIntegral = !this.isIntegral
    const res: any = await getIntegralDeduction({
      productPriceId: this.shoppingList[0].id,
      num: this.shoppingList[0].num,
      type: this.isIntegral ? 3 : 2,
      ieConfigId: this.isIntegral ? this.integralInfo.id : '',
      companyId: 1,
    })
    if (res.data.code === 100) {
      this.deductionList = res.data.data
      this.minInvoice = res.data.data.minInvoice
    }
    await this.getFreight()
    if (!this.isDeduction) {
      this.invoiceId = ''
      this.useIntegral = 0
    } else {
      this.$nextTick(() => {
        const ipt: any = (this.$refs.inputNumber as any)?.$el?.querySelector('input')
        if (ipt) ipt.setAttribute('readonly', true)
      })
    }
    // if (this.isIntegral && this.integralInfo.ruleType === 2) {
    //   this.total = this.freightprice;
    // } else {
    //   (this as any).changeUseInteral();
    // }
  }

  // 编辑收货地址
  setAddress() {
    this.showDialogBack = true
  }

  // 确认收货地址
  async confirmAddress(index: number) {
    this.currentIndex = index
    await this.getFreight()
    await this.changeUseInteral()
  }

  // 编辑发票信息
  editInvoice(item: any) {
    this.isEditInvoice = true
    this.form = item
    this.isSelectInvoice = true
  }

  //  确认订单信息
  private async setConfirmData() {
    this.isFromFlash = this.$route.query.from === 'flashsale'
    // 是否来自白拿的订单
    if (this.$route.query.from === 'takefree') {
      const res: any = await exchangeProductInfo({
        companyId: 1,
      })
      const recommendInfo = res.data.data
      const confirmlist = [
        {
          productId: recommendInfo.id,
          freight: null,
          id: recommendInfo.productPriceId,
          mallImage: {
            source_url: recommendInfo.listImagePath.sourceUrl,
            product_name: '',
          },
          natureList: [
            {
              id: '',
              index: 0,
              natureName: recommendInfo.natureValue,
              natureValue: '',
            },
          ],
          num: recommendInfo.buyNum,
          price: recommendInfo.lowestPrice.split(',')[0],
          totalPrice: _.round(
            _.multiply(Number(recommendInfo.lowestPrice.split(',')[0]), recommendInfo.buyNum),
            2
          ),
        },
      ]
      this.CONFIRMORDER(confirmlist)
    }
    this.shoppingList = this.orderdata.confirmlist
    console.log('this.shoppingList', JSON.stringify(this.shoppingList))
    this.cartIds = this.shoppingList.map((value: any) => value.id).join(',')
    this.limitNum = this.shoppingList[0].limit_num ? this.shoppingList[0].limit_num : Infinity
    // const type: number = Number(this.$route.query.type);
    const { type } = this.$route.query
    const res: any = await getIntegralDeduction({
      cartIds: type === '1' ? this.cartIds : '',
      productPriceId: type === '2' ? this.shoppingList[0].id : '',
      num: type === '2' ? this.shoppingList[0].num : '',
      type,
      companyId: 1,
    })
    if (res.data.code === 100) {
      this.deductionList = res.data.data
      this.minInvoice = res.data.data.minInvoice

      // 获取优惠卷列表
      await this.getUseCoupon()

      // 根据自动选中优惠卷
      if (this.deductionList.coupon) {
        this.couponIndex = this.deductionList.couponId
        this.couponPrice = this.couponList.filter(
          (item) => item.id === this.couponIndex
        )[0].reduceMoney
        this.isCoupon = true
        // this.$message.success('已领取优惠卷')
      } else {
        // this.$message.error('优惠卷失效')
      }

      if (this.deductionList.actualIntegral > 0) {
        setTimeout(() => {
          this.useIntegral = this.deductionList.actualIntegral
          this.changeUseInteral()
        }, 1000)
        this.isDeduction = true
      } else {
        this.useIntegral = 0
        this.isDeduction = false
      }
    } else {
      this.$message.error(res.data.message)
    }
  }

  // 获取全部地址列表信息
  private async addressLists() {
    const res: any = await addressList({
      pageNo: 1,
      pageSize: 20,
    })
    this.addLists = res.data.data
  }

  // 选择省份
  chooseProvince(id: number) {
    this.addRuleForm.provinceName = this.options.filter((e) => e.value === id)[0].label
    this.addRuleForm.cityId = this.options.filter((e) => e.value === id)[0].children[0].value
    this.addRuleForm.cityName = this.options.filter((e) => e.value === id)[0].children[0].label
    this.cityOptions = this.options.filter((e) => e.value === id)[0].children
    this.areaOptions = this.cityOptions.filter(
      (e) => e.value === this.addRuleForm.cityId
    )[0].children
    this.addRuleForm.areaId = this.cityOptions.filter(
      (e) => e.value === this.addRuleForm.cityId
    )[0].children[0].value
    this.addRuleForm.areaName = this.cityOptions.filter(
      (e) => e.value === this.addRuleForm.cityId
    )[0].children[0].label
    this.$nextTick(() => {
      ;(this as any).$refs.addRuleForm.clearValidate('areaId')
    })
  }

  // 选择市
  chooseCity(id: number) {
    this.addRuleForm.cityName = this.cityOptions.filter((e) => e.value === id)[0].label
    this.areaOptions = this.cityOptions.filter((e) => e.value === id)[0].children
    this.addRuleForm.areaId = this.cityOptions.filter((e) => e.value === id)[0].children[0].value
    this.addRuleForm.areaName = this.cityOptions.filter((e) => e.value === id)[0].children[0].label
    this.$nextTick(() => {
      ;(this as any).$refs.addRuleForm.clearValidate('areaId')
    })
  }

  // 选择区
  chooseArea(id: number) {
    this.addRuleForm.areaName = this.areaOptions.filter((e) => e.value === id)[0].label
    this.$nextTick(() => {
      ;(this as any).$refs.addRuleForm.clearValidate('areaId')
    })
  }

  // 模糊搜索公司
  private async searchCompany(queryString: string, cb: any) {
    this.loading = true
    const res: any = await searchInvoiceName({
      name: queryString,
    })
    if (res.data.code === 100) {
      const arr = res.data.data.map((element: any) => ({
        id: element.id,
        value: element.entname,
      }))
      cb(arr)
    }
    this.loading = false
  }

  // 根据公司名称查询税号
  private async searchNo(item: any) {
    const res: any = await searchInvoiceNo({ id: item.id })
    this.form.invoiceNo = res.data.data.taxNumber
  }

  // 保存收货地址
  private async saveAddress() {
    const form = this.$refs.addform as any
    form.validate(async (valid: boolean) => {
      if (valid) {
        this.addRuleForm.address = `${this.addRuleForm.provinceName}${this.addRuleForm.cityName}${this.addRuleForm.areaName}${this.addRuleForm.addressTemp}`
        if (this.addLists.length === 0) {
          this.addRuleForm.defaultAddress = 1
        }
        const res: any = await saveAddress(this.addRuleForm)
        if (res.data.code === 100) {
          this.$message.success('保存成功！')
          await this.addressLists()
          this.getAddress()
          this.showDialogBack = false
        } else {
          this.$message.error(res.data.message)
        }
      }
    })
  }

  // 总金额计算
  get totalPrice(): number {
    let totalSum = 0
    this.shoppingList.forEach((item) => {
      totalSum += _.multiply(item.price, item.num)
    })
    return _.round(totalSum, 2)
  }

  get activityDiscountDisplay(): number {
    if (this.isFromFlash) return 0
    return this.deductionList.marketingPrice || 0
  }

  get integralDeductionDisplay(): number {
    if (!this.isDeduction || this.isFromFlash) return 0
    const rule = this.deductionList.mallIntegralUseRule
    if (!rule || !rule.deductIntegral || !rule.deductAmount) return 0
    return _.round(this.useIntegral / (rule.deductIntegral / rule.deductAmount), 2)
  }

  get integralExchangeDisplay(): number {
    if (!this.isIntegral || this.isFromFlash || !this.integralInfo) return 0
    return this.integralInfo.ruleType === 1
      ? _.round(this.integralInfo.discountAmount, 2)
      : _.round(this.totalPrice, 2)
  }

  get totalReductionAmount(): number {
    if (this.isFromFlash) return 0
    const deductIntegral = this.deductionList.mallIntegralUseRule
      ? this.deductionList.mallIntegralUseRule.deductIntegral
      : 0
    const deductAmountRule = this.deductionList.mallIntegralUseRule
      ? this.deductionList.mallIntegralUseRule.deductAmount
      : 0
    let deductPrice = 0
    if (deductIntegral && deductAmountRule) {
      deductPrice = _.divide(_.divide(this.useIntegral, deductIntegral), deductAmountRule) || 0
    }
    let integralAmount = 0
    if (this.isIntegral && this.integralInfo) {
      integralAmount =
        this.integralInfo.ruleType === 1 ? this.integralInfo.discountAmount : this.totalPrice
    }
    const items = [
      deductPrice,
      integralAmount,
      this.deductionList.discountAmount || 0,
      this.couponPrice || 0,
      this.deductionList.marketingPrice || 0,
    ]
    return _.round(_.sum(items), 2)
  }

  get paymentSubtitle(): string {
    const totalItems = this.shoppingList.length
    const giftItems = this.shoppingList.filter((item: any) => this.isGiftRow(item)).length
    let text = `共${totalItems}件商品`
    if (giftItems > 0) {
      text += `，含${giftItems}件赠品`
    }
    return text
  }

  isGiftRow(row: any): boolean {
    return row.isGift === 1 || row.giftFlag === 1
  }

  // 全部地址列表
  private getAddressList() {
    this.isModifyAddress = false
    this.addressVisible = true
    this.addIndex = this.addLists.findIndex((e) => e.id === this.addressId)
    this.addressLists()
  }

  // 提交订单
  private async placeOrder() {
    if (this.isDeduction && this.useIntegral === 0) {
      this.$message.warning('勾选积分抵现后使用积分不能为0')
    } else if (this.isCoupon && !this.couponIndex) {
      this.$message.warning('勾选优惠券请选择需要使用的优惠券')
    } else if (this.isInvoice && this.selectInvoiceList.length === 0) {
      this.$message.warning('请选择发票')
    } else if (this.addressList.length !== 0 && !this.isdisabled) {
      const anchor = readCookie('anchor')
      if (this.invoiceId && this.$route.query.from) {
        const { from } = this.$route.query
        let url
        if (from === 'card') {
          url = getDataCard
        } else if (from === 'classify') {
          url = getDataProType
        } else if (from === 'carousel') {
          url = getDataBanner
        } else {
          url = getDataReCommend
        }
        url({
          src: anchor ? (anchor.src ? anchor.src : 2) : 4,
          equip: anchor ? anchor.equip : '',
          version: anchor ? anchor.version : '',
          model: anchor ? anchor.model : '',
          equipVersion: anchor ? anchor.equipVersion : '',
          equipMeid: anchor ? anchor.equipMeid : '',
          companyId: 1,
          // eslint-disable-next-line no-nested-ternary
          eventNo:
            from === 'card'
              ? '2.2.1.1.0.0.1'
              : from === 'classify'
              ? '2.3.1.1.1.0.1'
              : from === 'carousel'
              ? '2.4.1.1.0.0.1'
              : from === 'hotlist'
              ? '2.5.1.1.0.0.1'
              : '',
        })
      }
      if (this.$route.query.bargain) {
        const res: any = await createBargainOrder({
          productPriceId: this.cartIds,
          num: 1,
          configId: this.$route.query.configId,
          addressId: this.addressId,
          invoiceId: this.invoiceId,
          src: anchor ? (anchor.src ? anchor.src : 2) : 4,
          equip: anchor ? anchor.equip : '',
          version: anchor ? anchor.version : '',
          remark: this.remark,
          companyId: 1,
          shareUserId: 1,
        })
        if (res.data.code === 100) {
          if (this.total <= 0) {
            this.$router.push(`/payment-success?id=${res.data.data}`)
          } else {
            this.$router.push(`/payment?id=${res.data.data}`)
          }
        } else {
          this.$message.error(res.data.message)
        }
        return
      }
      const { type } = this.$route.query
      const deductIntegral = (this as any).deductionList.mallIntegralUseRule
        ? (this as any).deductionList.mallIntegralUseRule.deductIntegral
        : 0
      const deductAmount = (this as any).deductionList.mallIntegralUseRule
        ? (this as any).deductionList.mallIntegralUseRule.deductAmount
        : 0
      const integralAmount = _.round(
        _.divide(_.divide(this.useIntegral, deductIntegral), deductAmount),
        2
      )
      const obj: any = {
        cartIds: this.cartIds,
        productPriceId: this.cartIds,
        addressId: this.addressId,
        invoiceId: this.invoiceId,
        src: anchor ? (anchor.src ? anchor.src : 2) : 4,
        num: type === '2' ? this.shoppingList[0].num : '',
        panicBuyId: this.shoppingList[0].panicBuyId ? this.shoppingList[0].panicBuyId : '',
        shareUserId: '',
        totalAmount: this.total,
        equip: anchor ? anchor.equip : 4,
        version: anchor ? anchor.version : '',
        couponId: this.couponIndex,
        remark: this.remark,
        integral: this.useIntegral > 0 ? this.useIntegral : '',
        // eslint-disable-next-line no-nested-ternary
        integralAmount: this.useIntegral > 0 ? (integralAmount ? deductAmount : 0) : '',
        companyId: 1,
      }
      let url = type === '2' ? createOrderBuy : createOrder
      if (this.isIntegral && this.integralInfo) {
        url = integralExchangeOrder
        obj.integralExchangeId = this.integralInfo.id
      }
      const res: any = await url(obj)
      if (res.data.code === 100) {
        this.setCardNum()
        if (this.total <= 0) {
          this.$router.push(`/payment-success?id=${res.data.data}`)
        } else {
          this.$router.push(
            this.$route.query.from
              ? `/payment?id=${res.data.data}&from=${this.$route.query.from}`
              : `/payment?id=${res.data.data}`
          )
        }
      } else if (res.data.code === 2130) {
        this.$router.push('/card')
      } else {
        this.$message.error(res.data.message)
      }
      sessionStorage.removeItem('integralInfo')
    }
  }

  buildNewInvoice() {
    this.isEditInvoice = false
    this.isSelectInvoice = true
  }

  // 编辑地址信息
  modifyAddress(item: any, str: string) {
    this.isModifyAddress = str === 'single'
    this.isAddNewAddress = false
    this.addRuleForm = {
      id: item.id,
      realName: item.realName,
      cityId: item.cityCode,
      cityName: item.cityName,
      areaId: item.areaCode,
      areaName: item.areaName,
      address: item.address,
      telephone: item.telephone,
      defaultAddress: item.defaultAddress,
      provinceId: item.provinceCode,
      provinceName: item.provinceName,
      email: item.email,
      addressTemp: item.address.split(`${item.provinceName}${item.cityName}${item.areaName}`)[1],
    }
    this.cityOptions = this.options.filter((e) => e.value === item.provinceCode)[0].children
    this.areaOptions = this.cityOptions.filter(
      (e) => e.value === this.addRuleForm.cityId
    )[0].children
    this.showDialogBack = true
  }

  // 选择发票类别
  selectType(status: number, type?: string) {
    if (!(status === 2 && this.form.invoiceType === 3 && type)) {
      this.form.invoiceType = status
      const form = this.$refs.form as any
      form.clearValidate()
    }
  }

  //  获取收货地址列表
  private async getAddress() {
    const defaultAddress = this.addLists.filter((e: any) => e.defaultAddress === 1)
    const otherAddress = this.addLists.filter((e: any) => e.defaultAddress === 0)
    if (this.isModifyAddress) {
      const list = this.addLists.filter((e: any) => e.id === this.addRuleForm.id)[0]
      const index = this.addressList.findIndex((e) => e.id === this.addRuleForm.id)
      this.addressList.splice(index, 1, list)
    } else if (defaultAddress.length === 0 && otherAddress.length === 0) {
      this.addressList = []
    } else if (defaultAddress.length === 0 && otherAddress.length !== 0) {
      if (otherAddress.length === 1) {
        this.addressList = otherAddress
      } else {
        this.addressList = [otherAddress[0], otherAddress[1]]
      }
    } else if (defaultAddress.length !== 0 && otherAddress.length === 0) {
      this.addressList = defaultAddress
    } else if (this.isAddNewAddress) {
      this.addressList = [otherAddress[0], defaultAddress[0]]
    } else {
      this.addressList = [defaultAddress[0], otherAddress[0]]
    }
    this.getFreight()
  }

  private selectInvoice() {
    this.invoiceVisible = true
    this.getInvoiceList()
  }

  private async getInvoiceList() {
    this.invoiceVisible = true
    const res: any = await invoiceList({ pageNo: 1, pageSize: 40, companyId: 1 })
    if (res.data.code === 100) {
      this.invoiceList = res.data.data
    }
  }

  // 计算运费
  private async getFreight() {
    const address = this.addressList.filter((value, index) => index === this.currentIndex)
    this.addressId = address.length === 0 ? '' : address[0].id
    let num: number = 0
    this.shoppingList.forEach((item: any) => {
      num += item.num
    })
    let res: any = {}
    if (this.isIntegral) {
      res = await getFreight({
        addressId: this.addressId,
        productPriceId: this.cartIds,
        configId: this.integralInfo.id,
        type: 3,
        num,
        companyId: 1,
      })
    } else if (this.$route.query.from === 'bargain') {
      res = await getFreight({
        addressId: this.addressId,
        productPriceId: this.cartIds,
        configId: this.$route.query.configId,
        type: 4,
        num,
        companyId: 1,
      })
    } else {
      const { type } = this.$route.query
      res = await getFreight({
        addressId: this.addressId,
        cartIds: type === '1' ? this.cartIds : '',
        orderNo: '',
        productPriceId: type === '2' ? this.cartIds : '',
        num,
        type,
        companyId: 1,
      })
    }
    this.freightprice = res.data.data
    this.useIntegral = 0
    // this.total = _.round(_.add(this.totalPrice, this.freightprice), 2)
    //   - (this as any).deductionList.discountAmount
    //   - (this.couponPrice || 0);
    // (this as any).total = parseFloat((this as any).total).toFixed(2);
    // const objects = [
    //   { n: this.totalPrice },
    //   { n: this.freightprice },
    //   { n: -this.deductionList.discountAmount },
    //   { n: -this.couponPrice }
    // ];
    // this.total = _.round(_.sumBy(objects, 'n'), 2) < 0
    //   ? 0
    //   : _.round(_.sumBy(objects, 'n'), 2);
    // this.isInvoiceDisabled = _.subtract(this.total, this.minInvoice) < 0;
    // this.constTotal = this.total;
    // this.isdisabled = this.total > 100000;
    this.changeUseInteral()
  }

  private changeUseInteral() {
    // 积分抵扣
    let integralAmount
    if (this.isIntegral) {
      if (this.integralInfo.ruleType === 1) {
        integralAmount = this.integralInfo.discountAmount
      } else {
        integralAmount = this.totalPrice
      }
    } else {
      integralAmount = 0
    }
    const deductIntegral = (this as any).deductionList.mallIntegralUseRule
      ? (this as any).deductionList.mallIntegralUseRule.deductIntegral
      : 0
    const deductAmount = (this as any).deductionList.mallIntegralUseRule
      ? (this as any).deductionList.mallIntegralUseRule.deductAmount
      : 0
    const deductPrice = _.divide(_.divide(this.useIntegral, deductIntegral), deductAmount)
    const activityDiscount = this.deductionList.marketingPrice || 0
    const objects = [
      { n: this.totalPrice },
      { n: this.freightprice },
      // eslint-disable-next-line no-nested-ternary
      { n: this.isFromFlash ? 0 : deductPrice ? -deductPrice : 0 },
      { n: this.isFromFlash ? 0 : -integralAmount },
      { n: this.isFromFlash ? 0 : -this.deductionList.discountAmount },
      { n: this.isFromFlash ? 0 : -this.couponPrice },
      { n: this.isFromFlash ? 0 : -activityDiscount },
    ]
    this.total = _.round(_.sumBy(objects, 'n'), 2) < 0 ? 0 : _.round(_.sumBy(objects, 'n'), 2)
    this.isInvoiceDisabled = _.subtract(this.total, this.minInvoice) < 0
    this.isdisabled = this.total > 100000
  }

  private selectAddress(item: any, index: number) {
    this.addIndex = index
    if (this.addressList.length === 0) {
      this.addressList = [item]
    } else if (this.addressList.length === 1) {
      if (this.addressList[0].id !== item.id) {
        this.addressList = [item, ...this.addressList]
      }
    } else if (this.addressList[0].id !== item.id) {
      this.addressList = [item, this.addressList[0]]
    }
    if (this.addressList.some((e) => e.id === item.id)) {
      this.currentIndex = this.addressList.findIndex((e) => e.id === item.id)
    }
    this.getFreight()
    this.addressVisible = false
  }

  private chooseInvoice(item: any, index: number) {
    if (item.invoiceType === 3 && this.isInvoiceDisabled) return
    this.invoiceIndex = index
    this.selectInvoiceList = [item]
    this.invoiceId = item.id
    this.invoiceVisible = false
  }

  // 保存发票信息
  private async saveInvoice() {
    const form = this.$refs.form as any
    if (this.form.invoiceType === 1) {
      this.form = {
        id: this.form.id,
        invoiceType: 1,
        invoiceName: this.form.invoiceName,
        telephone: this.form.telephone,
        email: this.form.email,
        equip: '',
        version: '',
        invoiceNo: '',
        companyAddress: '',
        bankNo: '',
        bank: '',
        companyId: 1,
      }
    } else if (this.form.invoiceType === 2) {
      const anchor = readCookie('anchor')
      this.form = {
        id: this.form.id,
        // 所选发票类型(1、个人发票2、公司增值税电子普票3、增值税电子专票)
        invoiceType: 2,
        invoiceName: this.form.invoiceName,
        invoiceNo: this.form.invoiceNo,
        email: this.form.email,
        src: anchor ? (anchor.src ? anchor.src : 2) : 4,
        equip: anchor ? anchor.equip : 4,
        version: anchor ? anchor.version : '',
        companyId: 1,
      }
    }
    form.validate(async (valid: boolean) => {
      if (valid) {
        const res: any = await saveInvoice(this.form)
        if (res.data.code === 100) {
          this.getInvoiceList()
          this.isSelectInvoice = false
          this.$message.success('保存成功！')
        } else {
          this.$message.error(res.data.message)
        }
      }
    })
  }

  // 新增新地址信息
  addNewAddress() {
    this.isModifyAddress = false
    this.showDialogBack = true
    this.isAddNewAddress = true
    // const obj:any = {};
    // obj.stopPropagation = () => {};
    // (this.$refs as any).cascaderAddr.clearValue(obj);
    this.$nextTick(() => {
      const form = this.$refs.addform as any
      form.resetFields()
      this.value = []
      this.addRuleForm = {
        realName: '',
        cityId: '',
        cityName: '',
        areaId: '',
        areaName: '',
        address: '',
        area: '',
        telephone: '',
        defaultAddress: 0,
        provinceId: '',
        provinceName: '',
        addressTemp: '',
      }
    })
  }

  //  改变购买数量
  async changeNum(row: any, index: number) {
    updateBuyNum({
      cartId: row.id,
      buyNum: row.num,
      companyId: 1,
    })
    this.shoppingList[index].totalPrice = _.round(_.multiply(row.price, row.num), 2)
    await this.getUseCoupon()
    await this.setConfirmData()
    await this.getAddress()
  }

  // 访问页面数据埋点
  private pageVisit() {
    const anchor = readCookie('anchor')
    pageVisit({
      pageType: 9,
      equip: anchor ? anchor.equip : 4,
      version: anchor ? anchor.version : '',
      src: anchor ? (anchor.src ? anchor.src : 2) : 4,
      model: anchor ? anchor.model : '',
      equipVersion: anchor ? anchor.equipVersion : '',
      equipMeid: anchor ? anchor.equipMeid : '',
      companyId: 1,
    })
  }
}
